import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { createWeb3Modal } from '@web3modal/wagmi/react';
import { defaultWagmiConfig } from '@web3modal/wagmi/react/config';
import { WagmiProvider } from 'wagmi';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import {
  mainnet,
  aurora,
  arbitrum,
  avalanche,
  base,
  bsc,
  fantom,
  gnosis,
  klaytn,
  optimism,
  polygon,
  zkSync
} from '@wagmi/core/chains';

// 0. Setup queryClient
const queryClient = new QueryClient();

// 1. Get projectId from https://cloud.walletconnect.com
const projectId = '1938d8049d8eb3c187bd539fe05f43fd'; // Ensure this is the correct project ID from WalletConnect

// Determine the current environment and set the appropriate URL
const currentUrl = window.location.origin; // Gets the current origin (http://localhost:3000 in development, https://www.coinheatmap.com in production)

// 2. Create wagmiConfig
const metadata = {
  name: 'CoinHeatMap',
  description: 'Trade EVM coins easily',
  url: currentUrl, // Set dynamically based on current environment
  icons: ['https://avatars.githubusercontent.com/u/37784886']
};

const chains = [
  mainnet,
  aurora,
  arbitrum,
  avalanche,
  base,
  bsc,
  fantom,
  gnosis,
  klaytn,
  optimism,
  polygon,
  zkSync
];

const config = defaultWagmiConfig({
  chains,
  projectId,
  metadata,
});

// 3. Create modal
const web3Modal = createWeb3Modal({
  wagmiConfig: config,
  projectId,
  enableAnalytics: true, // Optional - defaults to your Cloud configuration
  enableOnramp: true // Optional - false as default
});

export function Web3ModalProvider({ children }) {
  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        {children}
      </QueryClientProvider>
    </WagmiProvider>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Web3ModalProvider>
      <BrowserRouter basename="/">
        <App />
      </BrowserRouter>
    </Web3ModalProvider>
  </React.StrictMode>
);

export { web3Modal }; // Exporting for use in other components
